import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

// Full class strings, not built from the tone name: Tailwind only generates
// classes it finds written out in the source.
const TONES = {
  primary: { chip: 'bg-primary-50 dark:bg-primary-900/20', icon: 'text-primary-600 dark:text-primary-400' },
  green: { chip: 'bg-green-50 dark:bg-green-900/20', icon: 'text-green-600 dark:text-green-400' },
  purple: { chip: 'bg-purple-50 dark:bg-purple-900/20', icon: 'text-purple-600 dark:text-purple-400' },
}

export interface SummaryCard {
  icon: LucideIcon
  label: string
  value: ReactNode
  tone: keyof typeof TONES
}

/**
 * The summary row above both Kampanjer grids (#631, #632). One component so
 * the loan and leasing tabs cannot drift apart: same cards, same order of
 * meaning — total, best price, brands.
 */
export default function SummaryCards({ cards }: { cards: SummaryCard[] }) {
  return (
    <div data-testid="kampanjer-summary" className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {cards.map(({ icon: Icon, label, value, tone }) => (
        <div key={label} data-testid="kampanjer-summary-card" className="card p-4">
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg ${TONES[tone].chip}`}>
              <Icon className={`w-5 h-5 ${TONES[tone].icon}`} />
            </div>
            <div>
              <p className="text-xs text-gray-600 dark:text-gray-400">{label}</p>
              <p className="text-xl font-bold text-gray-900 dark:text-gray-100">{value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
